module.exports = __webpack_public_path__ + "static/loading.d0ba90055e5a275761e79df0d7b0ff20.gif";